export default {
  reportGlobal: {
    cardTitle: 'Información de filtro',
    exportSuccessLabel: 'Archivo descargado exitosamente',
    loadingReportLabel: 'Cargando reporte, por favor espere...',
    exportErrorLabel: 'Error al descargar el archivo',
  },
  companySelector: {
    label: 'Empresa',
    placeholder: 'Seleccione una empresa',
    noActiveCompanies: 'No tiene empresas con servicio vigente. Contacte a soporte o al área comercial.',
  },
  expiredCompaniesDialog: {
    title: 'Suscripción vencida',
    message: 'El servicio de las siguientes empresas está vencido; ellas y sus sedes no se muestran en el sistema:',
    company: 'Empresa',
    endDate: 'Fecha de finalización',
    reason: 'Motivo',
    reasons: { G: 'Garantía', S: 'Suscripción' },
    allExpired: 'Todas sus empresas están vencidas. Contacte a soporte o al área comercial para renovar el servicio.',
    accept: 'Aceptar',
  },
  monthlyActiveReport: {
    title: 'Mensuales Activos',
    cardTitle: 'Información de filtro',
    company: 'Empresa',
    subscriptionType: 'Tipo de mensualidad',
    subscriptionTypePlaceholder: 'Seleccione clase de mensual',
    validity: 'Vigencia',
    validityPlaceholder: 'Estado de la vigencia del mensual',
    nameOrId: 'Nombre o cédula mensual',
    monthlyPlate: 'Placa mensual',
    search: 'Buscar',
    clean: 'Limpiar',
    export: 'Exportar',
    tableTitle: 'Tabla de previsualización',
    tableColId: 'Documento mensual',
    tableColName: 'Nombre mensual',
    tableColPlate: 'Placa',
    tableColNumOrId: 'Número de tarjeta o id',
    tableColMontlyName: 'Servicio mensual',
    tableColslot: 'Lote',
    tableColstartDate: 'Fecha desde',
    tableColendDate: 'Fecha hasta',
    tableColsubscriptionType: 'Tipo de mensual',
    tableColvehicleType: 'Tipo de vehículo',
    tableColmonthlyStatus: 'Estado de mensual',
    slot: 'Lote',
    slotPlaceholder: 'Seleccione el lote',
  },
  collectionReport: {
   collectionDetail:'Consolidado',
   collectionDetailPlaceholder: 'Detallado',

  },
  purgeMovement: {
    errors: {
      consecutiveTooLong: 'El consecutivo no puede tener más de 20 caracteres',
    }
  }
}
